import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	homeContent: {
		textAlign: 'center',
		whiteSpace: 'pre-line',
		maxWidth: '1000px'
	}
}));

export default function BucksContent() {
	const classes = useStyles();
	return(
		<div className={classes.homeContent}>
			<Typography>
			{'We currently do not have any bucks on our farm.'}
			</Typography>
		</div>
	);
};
